export * from './menuinfo-ui.component';
export * from './menuinfo-ui.module';